const closeButtonId = 'modal-close-button';
const modalId = 'modal';
const backdropId = 'backdrop';
const modalBackdropId = 'modal-backdrop';
const prevButtonId = 'modal-prev-button';
const nextButtonId = 'modal-next-button';
const modalImageId = 'modal-image';
const modalTitleId = 'modal-title';
const modalDescriptionId = 'modal-description';
const modalYearId = 'modal-year';
const modalCounterId = 'modal-counter';

interface GalleryImage {
	src: string;
	title: string;
	description: string;
	year: string;
	index: number;
}

let galleryImages: GalleryImage[] = [];
let currentIndex = 0;

function updateModalContent(): void {
	const imageElement = document.getElementById(modalImageId) as HTMLImageElement;
	const titleElement = document.getElementById(modalTitleId);
	const descriptionElement = document.getElementById(modalDescriptionId);
	const yearElement = document.getElementById(modalYearId);
	const counterElement = document.getElementById(modalCounterId);

	if (!imageElement || !titleElement) {
		return;
	}

	const currentImage = galleryImages[currentIndex];
	imageElement.src = currentImage.src;
	imageElement.alt = currentImage.title;
	titleElement.textContent = currentImage.title;

	if (descriptionElement) {
		descriptionElement.textContent = currentImage.description || '';
		descriptionElement.style.display = currentImage.description ? '' : 'none';
	}
	if (yearElement) {
		yearElement.textContent = currentImage.year || '';
		yearElement.style.display = currentImage.year ? '' : 'none';
	}

	if (counterElement) {
		counterElement.textContent = `${currentIndex + 1} / ${galleryImages.length}`;
	}

	// Update button states
	const prevButton = document.getElementById(prevButtonId);
	const nextButton = document.getElementById(nextButtonId);

	if (prevButton) {
		prevButton.classList.toggle('disabled', currentIndex === 0);
	}
	if (nextButton) {
		nextButton.classList.toggle('disabled', currentIndex === galleryImages.length - 1);
	}
}

function navigatePrev(): void {
	if (currentIndex > 0) {
		currentIndex--;
		updateModalContent();
	}
}

function navigateNext(): void {
	if (currentIndex < galleryImages.length - 1) {
		currentIndex++;
		updateModalContent();
	}
}

function closeModal(): void {
	const modalElement = document.getElementById(modalId);
	const backdropElement = document.getElementById(backdropId);

	if (modalElement) {
		modalElement.remove();
	}
	if (backdropElement) {
		backdropElement.remove();
	}
	document.body.classList.remove('modal-open');
	document.removeEventListener('keydown', keyboardHandler);
}

function clickCloseModalHandler(event: Event): void {
	const srcElement = event.target as HTMLElement;
	if (srcElement.id === modalBackdropId || srcElement.id === closeButtonId) {
		closeModal();
	}
}

function clickNavigationHandler(event: Event): void {
	event.preventDefault();
	event.stopPropagation();

	const target = event.currentTarget as HTMLElement;
	if (target.id === prevButtonId) {
		navigatePrev();
	} else if (target.id === nextButtonId) {
		navigateNext();
	}
}

function keyboardHandler(event: KeyboardEvent): void {
	switch (event.key) {
		case 'Escape':
			closeModal();
			break;
		case 'ArrowLeft':
			navigatePrev();
			break;
		case 'ArrowRight':
			navigateNext();
			break;
	}
}

function registerModalListeners(): void {
	const closeButtonElement = document.getElementById(closeButtonId);
	const closeModalElement = document.getElementById(modalBackdropId);
	const prevButton = document.getElementById(prevButtonId);
	const nextButton = document.getElementById(nextButtonId);

	if (closeButtonElement) {
		closeButtonElement.addEventListener('click', clickCloseModalHandler);
	}
	if (closeModalElement) {
		closeModalElement.addEventListener('click', clickCloseModalHandler);
	}
	if (prevButton) {
		prevButton.addEventListener('click', clickNavigationHandler);
	}
	if (nextButton) {
		nextButton.addEventListener('click', clickNavigationHandler);
	}

	document.addEventListener('keydown', keyboardHandler);
}

function openModal(index: number): void {
	currentIndex = index;
	const currentImage = galleryImages[currentIndex];

	const modalHtml = `
		<div id="${modalBackdropId}" class="modal gallery-modal" tabindex="-1" role="dialog" style="display: block;">
			<div class="modal-dialog modal-fullscreen" role="document">
				<div class="modal-content">

					<div class="gallery-modal__topbar">
						<span class="gallery-modal__counter" id="${modalCounterId}">${currentIndex + 1} / ${galleryImages.length}</span>
						<button id="${closeButtonId}" type="button" class="btn-close" aria-label="Close"></button>
					</div>

					<div class="modal-body d-flex align-items-center justify-content-center p-0">
						<img id="${modalImageId}" src="${currentImage.src}" alt="${currentImage.title}" class="gallery-modal__image img-fluid" />
					</div>

					<div class="gallery-modal__controls">
						<button id="${prevButtonId}" type="button" class="gallery-nav ${currentIndex === 0 ? 'disabled' : ''}" aria-label="Previous">
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
								<path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
							</svg>
						</button>
						<div class="gallery-modal__label">
							<p class="gallery-modal__label-title" id="${modalTitleId}">${currentImage.title}</p>
							<span class="gallery-modal__label-year" id="${modalYearId}" ${currentImage.year ? '' : 'style="display:none"'}>${currentImage.year}</span>
							<p class="gallery-modal__label-description" id="${modalDescriptionId}" ${currentImage.description ? '' : 'style="display:none"'}>${currentImage.description || ''}</p>
						</div>
						<button id="${nextButtonId}" type="button" class="gallery-nav ${currentIndex === galleryImages.length - 1 ? 'disabled' : ''}" aria-label="Next">
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
								<path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
							</svg>
						</button>
					</div>

				</div>
			</div>
		</div>
	`;

	const backdrop = document.createElement('div');
	backdrop.classList.add('modal-backdrop', 'fade', 'show');
	backdrop.id = backdropId;

	const element = document.createElement('div');
	element.innerHTML = modalHtml;
	element.id = modalId;

	document.body.appendChild(element);
	document.body.classList.add('modal-open');
	document.body.appendChild(backdrop);

	registerModalListeners();
}

function clickOpenModalHandler(event: Event): void {
	event.preventDefault();

	const target = event.currentTarget as HTMLElement;
	const index = parseInt(target.getAttribute('data-index') || '0', 10);

	openModal(index);
}

export function modal(buttonElementName: string): void {
	const buttonElements = document.getElementsByClassName(buttonElementName);

	// Build gallery images array
	galleryImages = [];
	for (let idx = 0; idx < buttonElements.length; idx++) {
		const element = buttonElements[idx] as HTMLElement;
		const src = element.getAttribute('data-full') || '';
		const title = element.getAttribute('data-title') || '';
		const description = element.getAttribute('data-description') || '';
		const year = element.getAttribute('data-year') || '';

		if (src) {
			galleryImages.push({
				src,
				title,
				description,
				year,
				index: idx,
			});
		}

		element.addEventListener('click', clickOpenModalHandler);
	}
}
